import Footer from '../component/Footer'
import background from '../images/background.png'
import Logo from '../images/logo.png'
import { FaArrowRight, FaCircleCheck } from 'react-icons/fa6'
import { getInnerPage, NAV_ITEMS } from './innerPageData'
import './InnerPage.css'

function InnerPage({ route }) {
  const page = getInnerPage(route)

  return (
    <section className="inner-page" style={{ backgroundImage: `url(${background})` }}>
      <div className="inner-page__overlay" />

      <div className="inner-page__container">
        <div className="inner-page__crumbs" aria-label="Inner page navigation">
          {NAV_ITEMS.map((item) => (
            <a key={item.path} href={item.path} className="inner-page__crumb">
              {item.label}
            </a>
          ))}
        </div>

        <div className="inner-page__hero">
          <div className="inner-page__copy">
            <span className="inner-page__eyebrow">{page.eyebrow}</span>
            <h1 className="inner-page__title">{page.title}</h1>
            <p className="inner-page__description">{page.description}</p>

            <div className="inner-page__actions">
              <a className="inner-page__button inner-page__button--primary" href={page.primaryCta.href}>
                <span>{page.primaryCta.label}</span>
                <FaArrowRight />
              </a>

              <a className="inner-page__button inner-page__button--secondary" href={page.secondaryCta.href}>
                {page.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="inner-page__visual">
            <div className="inner-page__visual-frame">
              <img src={Logo} alt="OBC logo" className="inner-page__visual-logo" />
            </div>

            <div className="inner-page__signal">
              <span className="inner-page__signal-label">Collector grade layout</span>
              <strong>Built to keep the important things visible.</strong>
            </div>
          </div>
        </div>

        <div className="inner-page__metrics">
          {page.metrics.map((metric) => (
            <article key={metric.label} className="inner-page__metric">
              <strong>{metric.value}</strong>
              <span>{metric.label}</span>
            </article>
          ))}
        </div>

        <div className="inner-page__grid">
          {page.cards.map((card) => (
            <article key={card.title} className="inner-page__card">
              <div className="inner-page__card-mark">
                <FaCircleCheck />
              </div>
              <h2>{card.title}</h2>
              <p>{card.text}</p>
            </article>
          ))}
        </div>

        {page.steps?.length ? (
          <div className="inner-page__steps">
            <h2>How it works</h2>
            <ol>
              {page.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </div>
        ) : null}

        <div className="inner-page__cta">
          <div>
            <span className="inner-page__cta-label">Need something specific?</span>
            <h2>Use the contact route for fast follow-up.</h2>
          </div>
          <a href="/contact" className="inner-page__cta-button">
            Contact Us
          </a>
        </div>
      </div>

      <Footer />
    </section>
  )
}

export default InnerPage
